module.exports = __webpack_public_path__ + "static/media/image_1.1f78cc52.svg";